const ageConfirmation = document.querySelector('.age-confirmation');

if (ageConfirmation) {
  const ageConfirmationContent = document.querySelector('.age-confirmation__content');

  attachEvent('.btn-age-confirm', 'click', () => {
    ageConfirmation.classList.remove('is-open');
    Cookies.set('age-confirmed', true, { expires: 365, secure: true });
    toggleBodyScrollLock(false);
  });

  attachEvent('.btn-age-deny', 'click', () => {
    // Slike sporočila za mladoletne se naložijo šele ob prikazu
    ageConfirmation.querySelectorAll('img[data-age-src]').forEach((img) => {
      img.src = img.dataset.ageSrc;
    });
    ageConfirmationContent.classList.add('display-success');
  });

  if (!Cookies.get('age-confirmed')) {
    ageConfirmation.classList.add('is-open');
    toggleBodyScrollLock(true);
  }
}
